// material
import { Container } from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from '../../routes/paths';
import { checkRoles, ROLE_USER } from 'guards/CheckRoles';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import axios from '../../utils/axios';
import { v4 as uuidv4 } from 'uuid';
import { useSnackbar } from 'notistack';
import { MIconButton } from '../../components/@material-extend';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { getProfile } from '../../redux/slices/user';
import { generatePath, useNavigate } from 'react-router-dom';
import { useDispatch } from '../../redux/store';
import DeliveryConfigurationForm from 'components/delivery-configuration/DeliveryConfigurationForm';
import { DeliveryConfiguration } from '../../@types/model/deliveryConfiguration';
import { useSetRecoilState } from 'recoil';
import { deliveryConfigurationState } from 'recoil/deliveryConfigurationState';
import { RootState, useSelector } from '../../redux/store';

// ----------------------------------------------------------------------
export default function AddDeliveryConfiguration() {
  const { themeStretch } = useSettings();
  const { t } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const applicationDispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.user);
  const { workspace } = useSelector((state: RootState) => state.workspace);
  const role = checkRoles(user, ROLE_USER) ? '/' : '/end-user';

  const [deliveryConfiguration, setDeliveryConfiguration] = useState<DeliveryConfiguration>({
    guid: uuidv4(),
    type: 'bulk',
    user: user?.id,
    units: 'Kg',
    workspace: workspace?.wsName,
    device_types: [],
    notify_to: [],
    configuration: {
      name: '',
      slots: 12,
      slot_amount: 1000,
      min: 1,
      max: 12,
      device_type: ''
    }
  } as DeliveryConfiguration);
  const { deliveryConfigurations } = useSelector((state: RootState) => state.user);
  const [loading, setLoading] = useState<boolean>(false);

  const saveDeliveryConfiguration = (deliveryConfiguration: DeliveryConfiguration) => {
    setLoading(true);
    const data = {
      ...deliveryConfiguration,
      device_types: [deliveryConfiguration.configuration.device_type],
      device_tags: []
    };
    axios.post('/api/v2/delivery-configuration', data).then(() => {
      setDeliveryConfiguration(deliveryConfiguration);
      enqueueSnackbar(t('delivery_configuration_created'), {
        variant: 'success',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });

      applicationDispatch(getProfile());

      setLoading(false);
      navigate(generatePath(PATH_DASHBOARD.deliveryConfigurations.list));
    });
  };

  const pageTitle = t('create_delivery_configuration');
  return (
    <Page title={pageTitle}>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading={pageTitle}
          links={[
            { name: t('home'), href: role },
            { name: t('delivery_configurations'), href: PATH_DASHBOARD.deviceGroups.list },
            { name: pageTitle, href: PATH_DASHBOARD.deviceGroups.new }
          ]}
        />
        <DeliveryConfigurationForm
          deliveryConfiguration={deliveryConfiguration}
          edit={false}
          submitHandler={saveDeliveryConfiguration}
          loading={loading}
        />
      </Container>
    </Page>
  );
}
